import {initWebComponent} from "@/helpers/web-component-helper";
import {clearGeoJsonLayers, setVisibleLayersIncludes} from "@/helpers/ol/ol-geo-json-helper";
import {getBySelector, hideElementsBySelector, showElementsBySelector} from "@/helpers/element-helper";
import {reloadCesium} from "@/modules/cesium/cesium";
import {loadInfoCharacteristics} from "@/helpers/layer/info/layer-info-characteristics-helper";
import {toggleCycloramaPlugin} from "@/helpers/ol/ol-plugin-helper.js";
import {getBookmarkPresentationsByID} from "@/helpers/ol/ol-layer-helper.js";

export class LayerInfoInfoItemHeaderComponent extends HTMLElement {
    constructor(){
        super();

        const mainTabName = this.getAttribute('data-main-tab-name')
        const bookmarkPresentationID = this.getAttribute('data-bookmark-presentation-name')
        const index = this.getAttribute('data-index')
        const active = this.getAttribute('data-class')

        const template = document.createElement('template');

        // template.innerHTML = `<div class="mr-2 info-menu-info-header-item bg-lighter">
        //     <div class="card-header p-0" style="border-bottom: 0">
        //       ` + mainTabName + `
        //     </div>
        //   </div>`

        // let active = ''
        // if(index == 0) {
        //     active = 'active'
        // }
        template.innerHTML = `
        <li class="nav-item">
          <a class="nav-link nav-link-info-header ` + active + `" data-toggle="tab" href="#Info">` + mainTabName + `</a>
        </li>`

        initWebComponent(this, template)

        this.addEventListener('click', () => {

            document.querySelectorAll('.nav-link-info-header').forEach(element => {
                if(element.innerHTML === mainTabName) {
                    element.classList.add('active')
                } else {
                    element.classList.remove('active')
                }
            })

            const navigation = document.querySelector('layer-info-info-item-filter-navigation')
            if(navigation) {
                const data = navigation.dataset
                if (data.bookmarkPresentationId === bookmarkPresentationID) {
                    navigation.classList.remove('d-none')
                } else {
                    navigation.classList.add('d-none')
                }
            }

            document.querySelectorAll('layer-info-info-item-header').forEach(element => {
                element.classList.remove('active')
            })

            let elementToShow = {}
            elementToShow.element = null
            elementToShow.depth = 0

            document.querySelectorAll('layer-info-info-item').forEach(element => {

                if(element.dataset.index === index && parseInt(element.dataset.depth) === 0) {

                    if(parseInt(element.dataset.depth) >= 0) {
                        elementToShow.element = element
                        elementToShow.depth = 0
                    }

                } else {
                    element.classList.add('d-none')
                }
            })

            setVisibleLayersIncludes()

            elementToShow.element.classList.remove('d-none')

            const switcherInput = elementToShow.element.querySelectorAll('.switcher-input')[0]
            if(switcherInput) {
                switcherInput.checked = false
                switcherInput.click()
            }

            this.classList.add('active')

            reloadCesium()

            loadInfoCharacteristics(bookmarkPresentationID, false)

            const bookmarkPresentation = getBookmarkPresentationsByID(bookmarkPresentationID)

            console.log(bookmarkPresentation)

            if(bookmarkPresentation.InfoBoxWidth) {
                getBySelector('.info-menu').style.width = bookmarkPresentation.InfoBoxWidth
            } else {
                getBySelector('.info-menu').style.width = window.settings.PopupBreedte
            }


            if(parseInt(bookmarkPresentationID) === window.cycloramaBookmarkPresentationID) {
                toggleCycloramaPlugin(true)
            } else {
                toggleCycloramaPlugin(false)
            }
        })
    }
}

